// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { MatterTemplateDeliverable } from "../../types";

const matterTemplateDeliverablesModule = {
  async findByMatterTemplateId(matterTemplateId: string): Promise<MatterTemplateDeliverable[]> {
    const result = await sql`
      SELECT * FROM matter_template_deliverables
      WHERE matter_template_id = ${matterTemplateId}
      ORDER BY position ASC, created_at ASC
    `;
    return (result || []) as MatterTemplateDeliverable[];
  },

  async create(data: Omit<MatterTemplateDeliverable, 'id' | 'created_at'>): Promise<MatterTemplateDeliverable> {
    const result = await sql`
      INSERT INTO matter_template_deliverables (matter_template_id, goal_template_id, position)
      VALUES (${data.matter_template_id}, ${data.goal_template_id}, ${data.position})
      RETURNING *
    `;
    return result[0] as MatterTemplateDeliverable;
  },

  async delete(id: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_template_deliverables
      WHERE id = ${id}
    `;
    return result.count > 0;
  },

  async deleteByMatterTemplateId(matterTemplateId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_template_deliverables
      WHERE matter_template_id = ${matterTemplateId}
    `;
    return result.count > 0;
  }
};

export type MatterTemplateDeliverablesModule = typeof matterTemplateDeliverablesModule;

export function registerMatterTemplateDeliverables(db: { matterTemplateDeliverables?: MatterTemplateDeliverablesModule }) {
  db.matterTemplateDeliverables = matterTemplateDeliverablesModule;
}

export { matterTemplateDeliverablesModule as matterTemplateDeliverables };
